// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 768px) {
  .incentive-banner-img {
    display: none;
  }
  .incentive-banner-img-desktop {
    width: 100%;
    height: 560px;
  }
}
@media only screen and (max-width: 767px) {
  .incentive-banner-img {
    width: 100%;
    height: 266px;
  }
  .incentive-banner-img-desktop {
    display: none;
  }
}
.header-wrapper {
  background-color: #ffffff;
  height: 54px;
  padding: 16px;
  display: flex;
  justify-content: center;
}
.header-wrapper .logo {
  height: 22px;
}
.header-wrapper .logo img {
  height: 22px;
}

.incentive-banner {
  display: flex;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/layout/Header/Header.scss"],"names":[],"mappings":"AAAA;EACE;IACE,aAAA;EACF;EACA;IACE,WAAA;IACA,aAAA;EACF;AACF;AAEA;EACE;IACE,WAAA;IACA,aAAA;EAAF;EAEA;IACE,aAAA;EAAF;AACF;AAEA;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;AAAF;AACE;EACE,YAAA;AACJ;AAAI;EACE,YAAA;AAEN;;AAEA;EACE,aAAA;EACA,UAAA;AACF","sourcesContent":["@media only screen and (min-width: 768px) {\n  .incentive-banner-img {\n    display: none;\n  }\n  .incentive-banner-img-desktop {\n    width: 100%;\n    height: 560px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .incentive-banner-img {\n    width: 100%;\n    height: 266px;\n  }\n  .incentive-banner-img-desktop {\n    display: none;\n  }\n}\n.header-wrapper {\n  background-color: #ffffff;\n  height: 54px;\n  padding: 16px;\n  display: flex;\n  justify-content: center;\n  .logo {\n    height: 22px;\n    img {\n      height: 22px;\n    }\n  }\n}\n.incentive-banner {\n  display: flex;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
